// ADD API URLS BELOW
export const API_URLS = {
    AUTH_LOGIN: '/api/auth/login',
    SEARCH: '/api/search/global',
    SEARCH_LOG_CLICK: '/api/search/logclick',
    SEARCH_LOG_VIEWED: '/api/search/logviewed',
    SEARCH_TYPEAHEAD: '/api/search/typeahead',
};
